import { Instagram } from "lucide-react";

const results = [
  { src: "/brand/ba-1.jpg", label: "Volume Restoration · Lips" },
  { src: "/brand/ba-2.jpg", label: "Volume Restoration · Lips" },
  { src: "/brand/ba-3.jpg", label: "Wrinkle Reduction · Forehead" },
  { src: "/brand/ba-4.jpg", label: "Wrinkle Reduction · Periorbital" },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 sm:py-32 bg-[#F5ECE1]/40 border-y border-[#E8E1DA]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 mb-12 reveal">
          <div>
            <p className="overline">Recent Results</p>
            <h2 className="font-serif-luxe mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
              Refined, balanced &<br />medically guided.
            </h2>
            <p className="mt-5 text-sm text-[#5C534B] max-w-md leading-relaxed">
              A selection of in-clinic results. Individual outcomes vary —
              every plan begins with an in-person assessment.
            </p>
          </div>
          <a
            href="https://instagram.com/face_itaesthetics"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta"
            className="inline-flex items-center gap-2 text-sm tracking-wide text-[#2C2723] border-b border-[#2C2723] pb-1 hover:text-[#8C6A53] hover:border-[#8C6A53] transition-colors w-fit"
          >
            <Instagram size={16} /> See more on Instagram
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {results.map((r, i) => (
            <figure
              key={i}
              data-testid={`gallery-tile-${i}`}
              className="reveal group relative overflow-hidden rounded-2xl bg-[#E8E1DA] aspect-square"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <img
                src={r.src}
                alt={`Before and after — ${r.label}`}
                loading="lazy"
                className="w-full h-full object-contain transition-transform duration-[1200ms] group-hover:scale-[1.03]"
              />
            </figure>
          ))}
        </div>

        <p
          className="mt-8 text-[11px] tracking-wide text-[#5C534B]/80 max-w-2xl"
          data-testid="gallery-disclaimer"
        >
          Results shown are of consenting clients of Face It Aesthetics. Outcomes
          are not guaranteed and vary per individual. Treatments are only
          provided to suitable candidates aged 18+ following an in-person
          consultation.
        </p>
      </div>
    </section>
  );
}
